import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface InsetWellProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** Remove padding. Default px-3 py-2. */
  flush?: boolean;
}

/** Recessed area: bg --bg, border --line, radius 2px (DESIGN_SYSTEM section 8.8). Depth goes down. */
export function InsetWell({ children, className, flush = false, ...rest }: InsetWellProps) {
  return (
    <div className={cn('rounded-sm border border-line bg-bg', flush ? '' : 'px-3 py-2', className)} {...rest}>
      {children}
    </div>
  );
}
